<script setup>
  import { useWebStore } from "~/store/web";
  import { useScrollToComponent } from "~/composables/useScrollToComponent";

  const store=useWebStore();
  const { scrollToComponent } = useScrollToComponent();
  const route = useRoute();

  

  //SETTING CHOSEN TAB (NEEDED IN CASE OF A LANGUAGE CHANGE)
  store.chosenTab = store.sites[1].url


  const productGroups=store.getProductTypes('bottles')


</script>
<template>
  <div class="p0 w100per">
    <banner-carousel
        :slides="[
            {title:store.getLocaleString('bbb1'), subtitle: store.getLocaleString('bbb2'), mobSubtitle:store.getLocaleString('bbb3'), image:'hotfill.webp',wide:true},
            {title:store.getLocaleString('bbb4'), subtitle: store.getLocaleString('bbb5'), image:'kornyezettudatossag.webp', wide:true},
            {title:store.getLocaleString('bbb6'), subtitle: store.getLocaleString('bbb7'), mobSubtitle:store.getLocaleString('bbb8'), image:'egyedi-tervezes.webp',wide:true},
            {title:store.getLocaleString('bbb9'), subtitle: store.getLocaleString('bbb10'),mobSubtitle:store.getLocaleString('bbb11'), image:'cimke-szita.webp', wide:true},
        ]"
        card-width="750px"
    />
    <AreasCarousel
        :slides="productGroups"
        @clickedOnSlide="scrollToComponent"
        :wrap="false"
        :items-to-show="store.getAreaBannerSlidesToShow()"
    />
    <enquiry-button @click="scrollToComponent('enquiry')"/>
    <h1 class="InterExtraBold text-3xl mt-8 md:text-4xl lg:text-5xl">{{ store.sites[1].text }}</h1>
    <title-text-image-template
        class="m-top-80 m-bot-80"
        :annotation="store.getLocaleString('bbtti1')"
        :title="store.getLocaleString('bbtti2')"
        :text0="store.getLocaleString('bbtti3')"
        :text1="store.getLocaleString('bbtti4')"
        image="BOTTLES_002.webp"
    />
    <h3 class="p-5 border-t-4 border-black text-2xl InterExtraBold uppercase " >{{store.getLocaleString('bb1')}} :</h3>
    <product-hero
        id="hotfill"
        :title="store.getLocaleString('bbpc11')"
        image="hotfill_banner.webp"
        :slogan="store.getLocaleString('bbpc12')"
        :text0="store.getLocaleString('bbpc13')"
        text1=""
        :list-items="store.getLocaleString('bbpc14')"
        :dark="true"
        :largeImage="true"
        :links="['https://flakon.hu/8-hotfill','https://flakon.hu/8-hotfill','https://flakon.hu/8-hotfill','https://flakon.hu/8-hotfill','https://flakon.hu/8-hotfill']"
    />
    <product-hero
        id="elelmiszeripar"
        :title="store.getLocaleString('bbpc21')"
        image="elelmiszeriparBanner.webp"
        :slogan="store.getLocaleString('bbpc22')"
        :text0="store.getLocaleString('bbpc23')"
        text1="Termékkatalógussal és rendeléssel kapcsolatban keresse webshopunkat:"
        :list-items="store.getLocaleString('bbpc24')"
        :dark="false"
        :largeImage="true"
        :links="['https://flakon.hu/13-viz','https://flakon.hu/16-etolaj','https://flakon.hu/15-tej','https://flakon.hu/13-viz','https://flakon.hu/13-viz']"
    />
    <product-hero
        id="szeszipar"
        :title="store.getLocaleString('bbpc31')"
        image="szesziparBanner.webp"
        :slogan="store.getLocaleString('bbpc32')"
        :text0="store.getLocaleString('bbpc33')"
        text1="Termékkatalógussal és rendeléssel kapcsolatban keresse webshopunkat:"
        :list-items="store.getLocaleString('bbpc34')"
        :dark="true"
        :largeImage="true"
        :links="['https://flakon.hu/17-bor','https://flakon.hu/18-soer','https://flakon.hu/19-palinka','https://flakon.hu/13-viz']"

    />
    <product-hero
        id="kozmetikai"
        :title="store.getLocaleString('bbpc41')"
        image="kozmetikaiBanner.webp"
        :slogan="store.getLocaleString('bbpc42')"
        :text0="store.getLocaleString('bbpc43')"
        text1="Termékkatalógussal és rendeléssel kapcsolatban keresse webshopunkat:"
        :list-items="store.getLocaleString('bbpc44')"
        :dark="false"
        :largeImage="true"
    />
    <product-hero
        id="asvanyi-olaj-kenoanyag"
        :title="store.getLocaleString('bbpc51')"
        image="olajosBanner.webp"
        :slogan="store.getLocaleString('bbpc52')"
        :text0="store.getLocaleString('bbpc53')"
        text1="Termékkatalógussal és rendeléssel kapcsolatban keresse webshopunkat:"
        :list-items="store.getLocaleString('bbpc54')"
        :dark="true"
        :largeImage="true"
    />
    <product-hero
        id="vegyipar"
        :title="store.getLocaleString('bbpc61')"
        image="vegyiBanner.webp"
        :slogan="store.getLocaleString('bbpc62')"
        :text0="store.getLocaleString('bbpc63')"
        text1="Termékkatalógussal és rendeléssel kapcsolatban keresse webshopunkat:"
        :list-items="store.getLocaleString('bbpc64')"
        :dark="false"
        :largeImage="true"
    />

    <ContactUsPage title="Keressen minket!"
                   subtitle="Forduljon hozzánk bizalommal"
                   contactPhone="+36 30 075 9259"
                   contact-email="biro.adrienn@poliol.hu"
                   contact-topic="bottleBlowing"

    />
    <CustomCarousel class="w-full middleMargin" :class="store.screenSize === 'mobile'? 'p0':'p-top-80'" bordered="false" :slides="['medikemia-logo.webp','szentkiralyi_logo.webp','fantana-mare_logo.webp','resilux_logo.webp','royalsekt_logo.webp','florin_logo.webp','caola_logo.webp']" />
    <footer-comp/>
  </div>
</template>